import React, {useEffect, useState} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";
import { TabPanel } from 'primereact/tabview';
import { TabView } from 'primereact/tabview';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from 'axios';
import download from "js-file-download";

import ManufacturerListComponent from "../../components/2.1/inventory/manufacturer/ManufacturerListComponent";
import ManufacturerFormComponent from "../../components/2.1/inventory/manufacturer/ManufacturerFormComponent";
import WarehouseListComponent from "../../components/2.1/inventory/warehouse/WarehouseListComponent";
import WarehouseFormComponent from "../../components/2.1/inventory/warehouse/WarehouseFormComponent";
import InventoryListComponent from "../../components/2.1/inventory/inventory/InventoryListComponent";
import MaterialListComponent from "../../components/2.1/inventory/material/MaterialListComponent";
import MaterialFormComponent from "../../components/2.1/inventory/material/MaterialFormComponent";
import MaterialcategoryFormComponent
  from "../../components/2.1/inventory/material-category/MaterialcategoryFormComponent";
import MaterialcategoryListComponent
  from "../../components/2.1/inventory/material-category/MaterialcategoryListComponent";
import InventorydocumentListComponent
  from "../../components/2.1/inventory/inventorydocument/InventorydocumentListComponent";
import InventorydocumentFormComponent
  from "../../components/2.1/inventory/inventorydocument/InventorydocumentFormComponent";
import InventoryGrnListComponent from "../../components/2.1/inventory/inventory-grn/InventoryGrnListComponent";
import InventorygrnFormComponent from "../../components/2.1/inventory/inventory-grn/InventorygrnFormComponent";
import EmployeeListComponent from '../../components/2.1/hr/empoloyee/EmployeeListComponent';
import InventorygrnShowComponent from "../../components/2.1/inventory/inventory-grn/InventorygrnShowComponent";
import ImportListComponent from "../../components/2.1/import/ImportListComponent";
import ImportFormComponent from "../../components/2.1/import/ImportFormComponent";
import PartnerListComponent from '../../components/2.1/partner/PartnerListComponent';
import InventorydocumentShowComponent from "../../components/2.1/inventory/inventorydocument/InventorydocumentShowComponent";
import InventoryMovementListComponent from "../../components/2.1/inventory/inventory-movement/InventoryMovementListComponent";
import InventoryDashboardComponent from '../../components/2.1/inventory/InventoryDashboardComponent';
import MaterialShowComponent from '../../components/2.1/inventory/material/MaterialShowComponent';
import PurchaseorderitemListComponent from "../../components/2.1/procurement/purchaseorderitem/PurchaseorderitemListComponent";
import MaterialSupplierPriceListComponent from "../../components/2.1/inventory/material-supplier-price/MaterialSupplierPriceListComponent";
import MaterialSupplierPriceFormComponent from "../../components/2.1/inventory/material-supplier-price/MaterialSupplierPriceFormComponent";
import InventoryLabelPrintDialog from "../../components/2.1/inventory/labelprint/InventoryLabelPrintDialog";

export const InventoryPage = (props) => {
  const {t} = props;

  const history = useHistory();
  const {module, entity, action, id} = useParams();
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [material, setMaterial] = useState({});
  const [inventoryGrn, setInventoryGrn] = useState({});
  const [inventoryDocument, setInventoryDocument] = useState({});
  const [inventoryMovementDetailedSearchVisible, setInventoryMovementDetailedSearchVisible] = useState(false);
  const [inventoryMovementDetailedSearchActive, setInventoryMovementDetailedSearchActive] = useState(false);
  const [inventoryDetailedSearchVisible, setInventoryDetailedSearchVisible] = useState(false);
  const [inventoryDetailedSearchActive, setInventoryDetailedSearchActive] = useState(false);
  const [warehouseTypes, setWarehouseTypes] = useState([]);
  const [selectedWarehouseType, setSelectedWarehouseType] = useState(null);
  const [materialLabelPrintVisible, setMaterialLabelPrintVisible] = useState(false);
  const currentInventoryDocumentView = window.App.urlVars().view;
  const normalizedRoles = (localStorage.getItem('roles') || '').toUpperCase();
  const canPrintInventoryLabels = normalizedRoles.includes('ROLE_INVENTORY_LABEL_PRINT');
  const materialSupplierPriceRead = ['ROLE_MATERIAL_PRODUCTION_READ', 'ROLE_MATERIAL_READ', 'ROLE_MATERIAL_TRADING_READ', 'ROLE_MATERIAL_OPERATIONS_READ']
    .some(role => normalizedRoles.includes(role));
  const materialSupplierPriceWrite = ['ROLE_MATERIAL_PRODUCTION_WRITE', 'ROLE_MATERIAL_WRITE', 'ROLE_MATERIAL_TRADING_WRITE', 'ROLE_MATERIAL_OPERATIONS_WRITE']
    .some(role => normalizedRoles.includes(role));

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const getPageTitle = () => {
    const view = window.App.urlVars().view;
    switch (view) {
        case 'inventory_count': return t('inventoryCount');
        case 'scrap_note': return t('scrapNotes');
        case 'transfer_supplier': return t('goodsReceipts');
        case 'pick_list': return t('picking');
        case 'relocation': return t('stockRelocation');
        case 'transfer_2st': return t('stockTransfer');
        case 'return_by_customer': return t('customerReturn');
        case 'return_to_supplier': return t('supplierReturn');
        case 'delivery_note': return t('goodsIssue');
        default: return t('goodsReceipts');
    }
  };

  const getFormTitle = () => {
    const view = window.App.urlVars().view;
    switch (view) {
        case 'inventory_count': return t('inventoryCount');
        case 'scrap_note': return t('scrapNotes');
        case 'transfer_supplier': return t('goodsReceipts');
        case 'pick_list': return t('picking');
        case 'relocation': return t('stockRelocation');
        case 'transfer_2st': return t('stockTransfer');
        case 'return_by_customer': return t('customerReturn');
        case 'return_to_supplier': return t('supplierReturn');
        case 'delivery_note': return t('goodsIssue');
        default: return t('goodsReceipts');
    }
  };

  useEffect(() => {
    document.title = t('App\\Inventory\\Menu') + ' - ' + process.env.REACT_APP_TITLE;
    setTimeout(function () {
      if (document.getElementsByClassName('activeMenu')[0]) {
        document.getElementsByClassName('activeMenu')[0].classList.remove("activeMenu")
      }
      if (document.getElementsByClassName('inventory')[0]) {
        document.getElementsByClassName('inventory')[0].classList.add("activeMenu")
      }
    }, 1000)
  }, [window.App.state.rerenderInventoryPage]);

  useEffect(() => {
    if (entity !== 'warehouse') return;
    apiCall('get', '/api/v2/dictionary/warehouse-type')
      .then(response => {
        setWarehouseTypes(response.data.data || []);
      })
      .catch(error => {
        setWarehouseTypes([]);
      });
  }, [entity]);

  return (
    <div className={"InventoryPage"}>
      {localStorage.getItem('module_inventory') ? (
        <>
          {entity === 'dashboard' &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <InventoryDashboardComponent />
            </div>
          }
          {entity === 'manufacturer' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_manufacturer_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('manufacturerList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {localStorage.getItem('roles').toString().includes('role_manufacturer_write') && (
                    <a onClick={() => {
                      history.push('/inventory/manufacturer/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>

                    &nbsp;
                    {t('addManufacturer')}
                  </a>
                  )}
                </div>
              </div>
              <Panel>
                <ManufacturerListComponent backlink={'/inventory/manufacturer'}/>
              </Panel>
            </div>
          }
          {entity === 'manufacturer' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                         history.push('/inventory/manufacturer')
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('manufacturerUpdate') : t('manufacturerCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        history.push('/inventory/manufacturer')
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <ManufacturerFormComponent backlink={'/inventory/manufacturer'}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'warehouse' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_warehouse_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('warehouseList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  <Dropdown
                    value={window.App.urlVars().warehouseType || selectedWarehouseType}
                    options={warehouseTypes}
                    optionLabel="value"
                    optionValue="key"
                    placeholder={t('selectWarehouseType')}
                    showClear
                    onChange={(e) => {
                      const value = e.value || null;
                      setSelectedWarehouseType(value);
                      if (value) {
                        history.replace('/inventory/warehouse?warehouseType=' + value);
                      } else {
                        history.replace('/inventory/warehouse');
                      }
                    }}
                  />
                  {localStorage.getItem('roles').toString().includes('role_warehouse_write') && (
                    <a onClick={() => {
                      history.push('/inventory/warehouse/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addWarehouse')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <WarehouseListComponent backlink={'/inventory/warehouse'} selectedWarehouseType={window.App.urlVars().warehouseType || selectedWarehouseType}/>
              </Panel>
            </div>
          }
          {entity === 'warehouse' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                         history.push('/inventory/warehouse')
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('warehouseUpdate') : t('warehouseCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        history.push('/inventory/warehouse')
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <WarehouseFormComponent backlink={'/inventory/warehouse'}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'inventory' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_inventory_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('inventoryList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  <Button
                    type="button"
                    label={t('detailedSearch')}
                    icon={inventoryDetailedSearchActive ? "pi pi-filter-fill" : "pi pi-filter"}
                    className="p-button-outlined p-mr-2"
                    onClick={() => setInventoryDetailedSearchVisible(v => !v)}
                  />
                </div>
              </div>
              <Panel>
                <InventoryListComponent backlink={'/inventory/inventory'} 
                  detailedSearchVisible={inventoryDetailedSearchVisible}
                  onDetailedSearchVisibleChange={setInventoryDetailedSearchVisible}
                  onDetailedSearchActiveChange={setInventoryDetailedSearchActive}/>
              </Panel>
            </div>
          }
          {entity === 'inventory-movement' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_inventory_movement_read') &&
          <div className={"PageContent p-p-5 p-mx-auto"}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  {t('inventoryMovementList')}
                </h2>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                <span className={"p-mr-2"}>

                </span>
                 <Button
                  type="button"
                  label={t('detailedSearch')}
                  icon={inventoryMovementDetailedSearchActive ? "pi pi-filter-fill" : "pi pi-filter"}
                  className="p-button-outlined p-mr-2"
                  onClick={() => setInventoryMovementDetailedSearchVisible(v => !v)}
                />
              </div>
            </div>
            <Panel>
              <InventoryMovementListComponent backlink={'/inventory/inventory-movement'} 
              detailedSearchVisible={inventoryMovementDetailedSearchVisible}
              onDetailedSearchVisibleChange={setInventoryMovementDetailedSearchVisible}
              onDetailedSearchActiveChange={setInventoryMovementDetailedSearchActive}/>
            </Panel>
          </div>
          }
          {entity === 'material' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('productMaster')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {localStorage.getItem('roles').toString().includes('role_material_write') && (
                    <a onClick={() => {
                      history.push('/inventory/material/create' + (history.location.search || ''));
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addProduct')}
                    </a>
                  )}
                  </div>
                </div>
                <Panel>
                  <MaterialListComponent backlink={'/inventory/material'}/>
                </Panel>
            </div>
          }
          {entity === 'material' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                         const currentView = window.App.urlVars().view;
                        history.push(`/inventory/material${currentView ? `?view=${currentView}` : ''}`);
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('productUpdate') : t('productCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        const currentView = window.App.urlVars().view;
                        history.push(`/inventory/material${currentView ? `?view=${currentView}` : ''}`);
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <MaterialFormComponent backlink={'/inventory/material'}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'material' && action === 'read' &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {material?.name}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  <a onClick={() => {
                    history.push('/inventory/material')
                  }}
                      className={"p-button  p-button-secondary p-ml-2"}>
                    <i className={"pi pi-arrow-left"}></i>
                    &nbsp;
                    {t('back')}
                  </a>
                  {canPrintInventoryLabels && (
                    <Button
                      label={t('printLabel')}
                      icon="pi pi-print"
                      className="p-ml-2"
                      disabled={!material?.id}
                      onClick={() => setMaterialLabelPrintVisible(true)}
                    />
                  )}
                </div>
              </div>
              <Panel>
                <TabView className="tabview-header-icon menu" style={{backgroundColor: 'white', border: 'none'}}>
                  <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6"}>
                        <div className={"p-grid"}>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                            <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                              {t('personalData')}
                            </h3>
                          </div>
                          {/* <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            <Button icon="pi pi-pencil" className="p-button-warning p-button-sm p-ml-2"
                                    label={t('editData')} tooltipOptions={{position: 'left'}}
                                    onClick={() => {
                                      history.push('/hr/employee/read/' + id + '?update=employee')
                                    }}/>
                          </div> */}
                        </div>
                        <MaterialShowComponent onLoaded={(material) => setMaterial(material || {})}/>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel header={t('tabPurchases')} leftIcon="pi pi-shopping-cart">
                    <PurchaseorderitemListComponent view={'material'} materialId={id} backlink={'/inventory/material'}/>
                  </TabPanel>
                  <TabPanel header={t('tabReport')} leftIcon="pi pi-chart-bar">
                    <InventoryDashboardComponent />
                  </TabPanel>
                </TabView>
              </Panel>
              {canPrintInventoryLabels && (
                <InventoryLabelPrintDialog
                  visible={materialLabelPrintVisible}
                  onHide={() => setMaterialLabelPrintVisible(false)}
                  materials={material?.id ? [material] : []}
                  source="material"
                />
              )}
            </div>
          }
          {entity === 'material-category' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_inventory_material_category_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('materialCategoryList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {localStorage.getItem('roles').toString().includes('role_inventory_material_category_write') && (
                    <a onClick={() => {
                      history.push('/inventory/material-category/create')
                    }}
                      className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addCategory')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <MaterialcategoryListComponent backlink={'/inventory/material-category'}/>
              </Panel>
            </div>
          }
          {entity === 'material-category' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                         history.push('/inventory/material-category')
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('categoryUpdate') : t('categoryCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        history.push('/inventory/material-category')
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <MaterialcategoryFormComponent backlink={'/inventory/material-category'}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'inventory-document' && (!action || action === 'update' || action === 'create' )  && localStorage.getItem('roles').toString().includes('role_') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {getPageTitle()}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {localStorage.getItem('roles').toString().includes('role_') && (
                    <a onClick={() => {
                      const currentView = window.App.urlVars().view;
                      history.push(`/inventory/inventory-document/create${currentView ? '?view=' + currentView : ''}`);
                    }}
                      className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {/* {window.App.urlVars().view === 'inventory_count' 
                      ? 'Leltár' 
                      : window.App.urlVars().view === 'scrap_note' 
                      ? 'Selejtezés' 
                      : window.App.urlVars().view === 'return_to_supplier' ? 'Új visszárú'
                      : 'Áruátvétel'} */}
                      {getFormTitle()}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <InventorydocumentListComponent view={window.App.urlVars().view} entity={'inventory-document'} backlink={'/inventory/inventory-document'}/>
              </Panel>
            </div>
          }
          {entity === 'inventory-document' && (action === 'create' || action === 'update' ) &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '85%'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                        history.push(`/inventory/inventory-document${history.location.search || ''}`);
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                      {getFormTitle()}{' '}
                      {/* {action === 'read'
                        ? 'megtekintése'
                        : (id ? 'módosítása' : 'létrehozása')} */}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update'  || action === 'read' ) {
                        // history.push('/inventory/transfer-supplier')
                        // history.goBack()
                        const currentView = window.App.urlVars().view;
                        history.push(`/inventory/inventory-document${currentView ? '?view=' + currentView : ''}`);
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') && (
                    <InventorydocumentFormComponent
                      view={window.App.urlVars().view}
                      entity="inventory-document"
                      // backlink="/inventory/transfer-supplier"
                    />
                  )}
                  {/* {action === 'read' && (
                    <InventorydocumentShowComponent
                      entity="transfer-supplier"
                      backlink="/inventory/transfer-supplier"
                    />
                  )} */}
                  {/* {action === 'read' && (
                    <InventorydocumentShowComponent
                      view={window.App.urlVars().view} 
                      entity="transfer-supplier"
                      // backlink="/inventory/transfer-supplier"
                    />
                  )} */}
                  <hr/>
                  {/* {action === 'read' && (
                    <TabView activeIndex={activeTabIndex} onTabChange={(e) => setActiveTabIndex(e.index)}>                      
                      <TabPanel header={t('tabPreview')} leftIcon="pi pi-eye">
                        <InventorydocumentShowComponent view="preview" entity="transfer-supplier" />
                      </TabPanel>

                      <TabPanel header={t('tabDocumentImage')} leftIcon="pi pi-file">
                        <InventorydocumentShowComponent
                          view="file"
                          entity="transfer-supplier"
                        />
                      </TabPanel>
                    </TabView>
                  )} */}
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'inventory-grn' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_inventory_grn_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('goodsReceipt')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {localStorage.getItem('roles').toString().includes('role_inventory_grn_write') && (
                    <a onClick={() => {
                      history.push('/inventory/inventory-grn/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {/* Új beszerzés szállítólevél alapján */}
                      {t('addGoodsReceipt')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <InventoryGrnListComponent backlink={'/inventory/inventory-grn'}/>
              </Panel>
            </div>
          }
          {entity === 'inventory-grn' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '980px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update' || action === 'read') {
                         history.push('/inventory/inventory-grn')
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {/* Beszerzés szállítólevél alapján */}
                      {t('goodsReceipt')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update'  || action === 'read' ) {
                        history.push('/inventory/inventory-grn')
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                  <InventorygrnFormComponent backlink={'/inventory/inventory-grn'}/>
                  }
                  {/* {action === 'read' &&
                  <InventorygrnShowComponent backlink={'/inventory/inventory-grn'}/>
                  } */}
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'inventory-grn' && action === 'read' &&
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                    {inventoryGrn?.grn_number}
                  </h2>
                </div>

                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                  <a
                    onClick={() => {
                      const currentView = window.App.urlVars().view;
                      history.push(`/inventory/inventory-grn${currentView ? '?view=' + currentView : ''}`);
                    }}
                    className="p-button p-button-secondary p-ml-2"
                  >
                    <i className="pi pi-arrow-left" /> &nbsp; {t('back')}
                  </a>
                </div>
              </div>

              <Panel>
                <TabView activeIndex={activeTabIndex} onTabChange={(e) => setActiveTabIndex(e.index)}>
                  <TabPanel header={t('tabPreview')} leftIcon="pi pi-eye">
                    <InventorygrnShowComponent backlink={'/inventory/inventory-grn'} onLoaded={(inventoryGrn) => setInventoryGrn(inventoryGrn || {})} />
                  </TabPanel>
                </TabView>
              </Panel>
            </div>
          }
          {entity === 'inventory-document' && action === 'read' &&
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                    {inventoryDocument?.document_number}
                  </h2>
                </div>

                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                  <a
                    onClick={() => {
                      const currentView = window.App.urlVars().view;
                      history.push(`/inventory/inventory-document${currentView ? '?view=' + currentView : ''}`);
                    }}
                    className="p-button p-button-secondary p-ml-2"
                  >
                    <i className="pi pi-arrow-left" /> &nbsp; {t('back')}
                  </a>
                </div>
              </div>

              <Panel>
                <TabView activeIndex={activeTabIndex} onTabChange={(e) => setActiveTabIndex(e.index)}>
                  <TabPanel header={t('tabView')} leftIcon="pi pi-eye">
                    <InventorydocumentShowComponent view="preview" entity="inventory-document" onLoaded={(inventoryDocument) => setInventoryDocument(inventoryDocument || {})} />
                  </TabPanel>

                  {currentInventoryDocumentView === 'transfer_supplier' && 
                  <TabPanel header={t('tabDocumentImage')} leftIcon="pi pi-file">
                    <div style={{ width: '100%', textAlign: 'right', marginBottom: '1rem' }}>
                      <Button
                        icon="pi pi-download"
                        className="p-button-secondary"
                        label={t('download')}
                        disabled={!inventoryDocument?.file?.id}
                        onClick={() => {
                          const fileId = inventoryDocument?.file?.id;
                          if (!fileId) {
                            window.App.toastShow('warn', 'Figyelem', props.t('noAttachedDocumentImage'));
                            return;
                          }
                          axios.get(
                            process.env.REACT_APP_API_HOST + `/api/v2/file/${fileId}/download`,
                            {
                              responseType: 'blob',
                              headers: {
                                'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                'App-Network': localStorage.getItem("networkId")
                              }
                            }
                          ).then(response => {
                            const filename = inventoryDocument?.document_number
                              ? `${inventoryDocument.document_number}.pdf`
                              : `file-${fileId}.pdf`;
                            download(response.data, filename);
                          }).catch(error => {
                            window.App.toastShow('error', props.t('error'), error.toString(), '', error.response);
                          });
                        }}
                      />
                    </div>
                    <InventorydocumentShowComponent view="file" entity="inventory-document" onLoaded={(inventoryDocument) => setInventoryDocument(inventoryDocument || {})} />
                  </TabPanel>
                  }
                </TabView>
              </Panel>
            </div>
          }
          {entity === 'material-supplier-price' && materialSupplierPriceRead && (!action || action === 'create' || action === 'update' || action === 'import') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center"}><h2 className={"p-m-0 text-primary"}>{t('materialSupplierPriceList')}</h2></div>
                <div className={"p-col-12 p-lg-6 p-text-right"}>
                  {materialSupplierPriceWrite && <Button label={t('tabImport')} icon="pi pi-upload" className="p-button-secondary p-mr-2" onClick={() => history.push('/inventory/material-supplier-price/import')}/>}
                  {materialSupplierPriceWrite && <Button label={t('addMaterialSupplierPrice')} icon="pi pi-plus" className="p-button-success" onClick={() => history.push('/inventory/material-supplier-price/create')}/>}
                </div>
              </div>
              <Panel><MaterialSupplierPriceListComponent/></Panel>
            </div>
          }
          {entity === 'material-supplier-price' && materialSupplierPriceWrite && (action === 'create' || action === 'update') &&
            <Sidebar position="left" showCloseIcon={false} visible style={{width:'780px'}} onHide={() => history.push('/inventory/material-supplier-price')}>
              <div className="PageContent p-px-1 p-py-3"><h2 className="text-primary">{id ? t('materialSupplierPriceUpdate') : t('materialSupplierPriceCreate')}</h2>
                <Panel><MaterialSupplierPriceFormComponent backlink="/inventory/material-supplier-price"/></Panel>
              </div>
            </Sidebar>
          }
          {entity === 'material-supplier-price' && materialSupplierPriceWrite && action === 'import' &&
            <Sidebar position="left" showCloseIcon={false} visible style={{width:'780px'}} onHide={() => history.push('/inventory/material-supplier-price')}>
              <div className="PageContent p-px-1 p-py-3"><h2 className="text-primary">{t('materialSupplierPriceImport')}</h2>
                <Panel><ImportFormComponent backlink="/inventory/material-supplier-price" importType="material_supplier_price" templateUrl="/api/v2/material-supplier-price/import-template" templateFilename="material_supplier_price_import_template.xlsx"/></Panel>
                <h3>{t('importProcesses')}</h3>
                <Panel><ImportListComponent importType="material_supplier_price"/></Panel>
              </div>
            </Sidebar>
          }
          {entity === 'import'  && localStorage.getItem('roles').toString().includes('role_import_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('productMasterImports')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                  </span>
                  {localStorage.getItem('roles').toString().includes('role_import_write') && (
                    <a onClick={() => {
                      history.push('/inventory/import/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                    &nbsp;
                    {t('addProductMasterImport')}
                  </a>
                  )}
                </div>
              </div>
              <Panel>
                <ImportListComponent backlink={'/inventory/import'}/>
              </Panel>
            </div>
          }
          {entity === 'import' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       history.goBack()
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('productMasterImportUpdate') : t('productMasterImportCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                  </span>
                    <a onClick={() => {
                      history.goBack()
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <ImportFormComponent backlink={'/inventory/import'} view="inventory"/>
                </Panel>
              </div>
            </Sidebar>
          }


          {/* inventory/inventory-document partner search */}
          <Sidebar
                      position="bottom"
                      visible={window.App.urlVars().search === 'partner'}
                      closeOnEscape
                      style={{ width: '100%', height: '80%' }}
                      onHide={() => {
                        const basePath =
                          '/inventory/' +
                          entity + '/' +
                          action +
                          (id && id !== 'undefined' ? '/' + id : '');
                        const vars = window.App.urlVars();
                        const newVars = { ...vars };
                        delete newVars.search;
          
                        let query = '?';
                        Object.entries(newVars).forEach(([key, value]) => {
                          if (value !== undefined && value !== null && value !== '') {
                            query += key + '=' + value + '&';
                          }
                        });
                        history.push(basePath + query);
                      }}
                    >
                      <div className="p-grid p-mt-3">
                        <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                          <h3 className="p-m-0 p-p-0 text-primary p-d-inline">{t('partnerSearch')}</h3>
                        </div>
                        <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"></div>
                      </div>
                      <Panel>
                        <PartnerListComponent
                          view="search"
                          backlink={
                            '/inventory/' +
                            entity + '/' +
                            action +
                            (id && id !== 'undefined' ? '/' + id : '')
                          }
                        />
                      </Panel>
                    </Sidebar>


          {/* warehouse kereső */}
          <Sidebar
                      position="bottom"
                      visible={window.App.urlVars().search === 'warehouse'}
                      closeOnEscape
                      style={{ width: '100%', height: '80%' }}
                      onHide={() => {
                        const basePath =
                          '/inventory/' +
                          entity + '/' +
                          action +
                          (id && id !== 'undefined' ? '/' + id : '');
                        const vars = window.App.urlVars();
                        const newVars = { ...vars };
                        delete newVars.search;
          
                        let query = '?';
                        Object.entries(newVars).forEach(([key, value]) => {
                          if (value !== undefined && value !== null && value !== '') {
                            query += key + '=' + value + '&';
                          }
                        });
                        history.push(basePath + query);
                      }}
                    >
                      <div className="p-grid p-mt-3">
                        <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                          <h3 className="p-m-0 p-p-0 text-primary p-d-inline">{t('warehouseSearch')}</h3>
                        </div>
                        <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"></div>
                      </div>
                      <Panel>
                        <WarehouseListComponent
                          view="search"
                          backlink={
                            '/inventory/' +
                            entity + '/' +
                            action +
                            (id && id !== 'undefined' ? '/' + id : '')
                          }
                        />
                      </Panel>
                    </Sidebar>


          {/* inventory/material-category értesített beszerző search */}
          <Sidebar
            position="bottom"
            visible={window.App.urlVars().search === 'employee'}
            closeOnEscape
            appendTo={document.body}
            blockScroll
            style={{ width: '100%', height: '80%' }}
            onHide={() => {
              const vars = window.App.urlVars();
              const newVars = { ...vars };
              delete newVars.search;

              let query = '?';
              Object.entries(newVars).forEach(([k, v]) => {
                if (v !== undefined && v !== null) query += k + '=' + v + '&';
              });
              const basePath =
                '/' + (module || 'inventory') + '/' +
                entity + '/' +
                action +
                (id && id !== 'undefined' ? '/' + id : '');

              history.push(basePath + query);
            }}
          >
            <div className="p-grid p-mt-3">
              <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                <h3 className="p-m-0 p-p-0 text-primary p-d-inline">{t('notifiedBuyerSearch')}</h3>
              </div>
              <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right" />
            </div>
            <Panel>
              <EmployeeListComponent
                view="search"
                backlink={
                  '/' + (module || 'inventory') + '/' +
                  entity + '/' +
                  action +
                  (id && id !== 'undefined' ? '/' + id : '')
                }
              />
            </Panel>
          </Sidebar>


        </>
      ) : (
        <p className={"p-text-center p-my-5 p-py-5"}>
          <i className={"pi pi-exclamation-circle p-d-block p-mb-5"} style={{'fontSize': '5em'}}></i>
          <span className={"p-text-bold p-d-block "}>{t('moduleNoAccess')}</span>
          {t('moduleNoAccessContact')} {process.env.REACT_APP_DEVOPS_CONTACT} {t('emailAddressSuffix')}
          {process.env.REACT_APP_SUBSCRIPTIONS === 'enabled' &&
            <span className={"p-text-bold p-d-block p-mt-5"}>
                       <a className={"p-button p-button-warning"}
                          onClick={() => {
                            window.location.replace('/#/subscriptions');
                            window.App.forceUpdate()
                          }}
                       >
                         <i className={"pi pi-building"}></i>&nbsp;{t('subscriptionAccountOverview')}
                       </a>
                   </span>
          }
        </p>
      )
      }
    </div>
  )
}
export default withTranslation('common')(InventoryPage);
